var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2367 15.6864C11.8131 15.6864 10.5824 14.8811 9.96991 13.7014H13.2367L13.8038 12.5671H9.5956C9.56724 12.38 9.55023 12.1928 9.55023 12C9.55023 11.8072 9.56724 11.62 9.5956 11.4329H13.2367L13.8038 10.2986H9.96991C10.5824 9.11891 11.8188 8.31357 13.2367 8.31357C14.1498 8.31357 14.9891 8.64818 15.6357 9.20398L16.6395 8.20014C15.7378 7.38912 14.5411 6.89571 13.2367 6.89571C11.0135 6.89571 9.13054 8.31924 8.42728 10.2986H6.43094L5.86379 11.4329H8.1664C8.14371 11.62 8.13237 11.8072 8.13237 12C8.13237 12.1928 8.14371 12.38 8.1664 12.5671H6.43094L5.86379 13.7014H8.42728C9.13054 15.6808 11.0135 17.1043 13.2367 17.1043C14.5468 17.1043 15.7378 16.6109 16.6395 15.7999L15.63 14.796C14.9891 15.3518 14.1554 15.6864 13.2367 15.6864Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/Euro.2dce4b968499236862a6909ea3439c5c.svg";
export { ForwardRef as ReactComponent };